import { IKhoi } from "../../../model/respone/category/IKhoi";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eKhoiActionTypeIds {
    LOAD_START = "Khoi_LOAD_START",
    LOAD_SUCCESS = "Khoi_LOAD_SUCCESS",
    LOAD_ERROR = "Khoi_LOAD_ERROR"
}
export interface IKhoiLoadStart extends IActionTypeBase<eKhoiActionTypeIds.LOAD_START, undefined> { }
export interface IKhoiLoadSuccess extends IActionTypeBase<eKhoiActionTypeIds.LOAD_SUCCESS, IKhoi[]> { }
export interface IKhoiLoadError extends IActionTypeBase<eKhoiActionTypeIds.LOAD_ERROR, string | undefined> { }

export type IKhoiActionTypes = IKhoiLoadStart | IKhoiLoadSuccess | IKhoiLoadError